"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _InputGroupWithSubdomain = _interopRequireDefault(require("../../../ui-components/InputGroupWithSubdomain"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _PanelItems = require("../PanelItems");

var ZendeskInstallationPanelBody = function ZendeskInstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onApiTokenChangeCallback = _ref.onApiTokenChangeCallback,
      onApiTokenClickCallback = _ref.onApiTokenClickCallback,
      onSubdomainChangeCallback = _ref.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref.onSubdomainClickCallback,
      apiToken = _ref.apiToken,
      subdomain = _ref.subdomain,
      _onClickManage = _ref.onClickManage,
      _onClickUninstall = _ref.onClickUninstall,
      errorFields = _ref.errorFields,
      agentEmail = _ref.agentEmail,
      onAgentEmailChangeCallback = _ref.onAgentEmailChangeCallback,
      onAgentEmailClickCallback = _ref.onAgentEmailClickCallback,
      isSavingCredentials = _ref.isSavingCredentials;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To install Zendesk, you\u2019ll need"), (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("ul", {
    className: "panel-body-description-unordered-list"
  }, (0, _preact.h)("li", null, (0, _preact.h)("span", {
    className: "text--bold panel-body-description-label"
  }, "Admin permissions:"), (0, _preact.h)("span", {
    className: "panel-body-description-label-meta"
  }, ' ', "Admin permissions required to generate an API key from Zendesk.")))), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-subdomain"
  }, (0, _preact.h)(_InputGroupWithSubdomain.default, {
    key: "subdomain",
    title: "Subdomain",
    required: true,
    meta: "This is your registered domain name at Zendesk.com.",
    error: (0, _PanelItems.getErrorMessage)('subdomain', errorFields),
    qaClasses: "qa-subdomain-input",
    value: subdomain,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onSubdomainChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onSubdomainClickCallback();
    },
    subdomain: ".zendesk.com"
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-agent-email"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "agentEmail",
    title: "Agent email",
    meta: "Email address you use to login to Zendesk. Please note that this email will  be used as the 'submitter' when creating tickets from community posts on behalf of anonymised users.",
    error: (0, _PanelItems.getErrorMessage)('agentEmail', errorFields),
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-agent-email-input",
    value: agentEmail,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onAgentEmailChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onAgentEmailClickCallback();
    }
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-api-token"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "apiToken",
    title: "API token",
    meta: "You can create an API token in Zendesk via Admin > Channels > API.",
    error: (0, _PanelItems.getErrorMessage)('apiToken', errorFields),
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-api-token-input",
    value: apiToken,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onApiTokenChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onApiTokenClickCallback();
    }
  })), isInstalled ? (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
    onClickManage: function onClickManage() {
      return _onClickManage();
    },
    onClickUninstall: function onClickUninstall() {
      return _onClickUninstall();
    }
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    },
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isSavingCredentials
  }));
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      _onSave2 = props.onSave,
      _onCancel2 = props.onCancel,
      _onApiTokenChangeCallback = props.onApiTokenChangeCallback,
      _onApiTokenClickCallback = props.onApiTokenClickCallback,
      _onSubdomainChangeCallback = props.onSubdomainChangeCallback,
      _onSubdomainClickCallback = props.onSubdomainClickCallback,
      _onClickManage2 = props.onClickManage,
      _onClickUninstall2 = props.onClickUninstall,
      apiToken = props.apiToken,
      subdomain = props.subdomain,
      agentEmail = props.agentEmail,
      _onAgentEmailChangeCallback = props.onAgentEmailChangeCallback,
      _onAgentEmailClickCallback = props.onAgentEmailClickCallback,
      errorFields = props.errorFields,
      hasUnsavedChanges = props.hasUnsavedChanges,
      isSavingCredentials = props.isSavingCredentials;
  return {
    body: (0, _preact.h)(ZendeskInstallationPanelBody, {
      isInstalled: isInstalled,
      onSave: function onSave() {
        return _onSave2();
      },
      onCancel: function onCancel() {
        return _onCancel2();
      },
      onApiTokenChangeCallback: function onApiTokenChangeCallback(apiToken) {
        return _onApiTokenChangeCallback(apiToken);
      },
      onApiTokenClickCallback: function onApiTokenClickCallback() {
        return _onApiTokenClickCallback();
      },
      onSubdomainChangeCallback: function onSubdomainChangeCallback(subdomain) {
        return _onSubdomainChangeCallback(subdomain);
      },
      onSubdomainClickCallback: function onSubdomainClickCallback() {
        return _onSubdomainClickCallback();
      },
      onClickManage: function onClickManage() {
        return _onClickManage2();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall2();
      },
      apiToken: apiToken,
      subdomain: subdomain,
      agentEmail: agentEmail,
      onAgentEmailChangeCallback: function onAgentEmailChangeCallback(agentEmail) {
        return _onAgentEmailChangeCallback(agentEmail);
      },
      onAgentEmailClickCallback: function onAgentEmailClickCallback() {
        return _onAgentEmailClickCallback();
      },
      errorFields: errorFields,
      isSavingCredentials: isSavingCredentials
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
}